/** 1단계에서 이월된 i18n. 데모 페이지가 아니라 컴포넌트 층에 있어야 할 것. */

export interface Messages {
  pick: string;
  hint: string;
  auto: string;
  lasso: string;
  modeReplace: string;
  modeAdd: string;
  modeSubtract: string;
  modeGroup: string;
  applySel: string;
  cancelSel: string;
  undoStep: string;
  selHint: string;
  refineOn: string;
  refineOff: string;
  refineGroup: string;
  undo: string;
  redo: string;
  reset: string;
  resetView: string;
  zoomIn: string;
  zoomOut: string;
  zoomGroup: string;
  save: string;
  another: string;
  analyzing: string;
  retry: string;
  canvasLabel: string;
}

export const ko: Messages = {
  pick: '사진 선택',
  hint: 'JPG · PNG · WebP · 최대 15MB',
  auto: '영역 자동맞춤',
  lasso: '올가미',
  modeReplace: '새 영역',
  modeAdd: '추가',
  modeSubtract: '빼기',
  modeGroup: '올가미 동작',
  applySel: '적용',
  cancelSel: '선택 해제',
  undoStep: '한 단계 취소',
  selHint: '선택 영역을 다듬은 뒤 적용하세요',
  refineOn: 'AI 보정',
  refineOff: '영역 그대로',
  refineGroup: '올가미 보정 방식',
  undo: '되돌리기',
  redo: '다시',
  reset: '초기화',
  resetView: '맞춤',
  zoomIn: '확대',
  zoomOut: '축소',
  zoomGroup: '확대·축소',
  save: 'PNG 저장',
  another: '다른 사진',
  analyzing: 'AI 분석 중…',
  retry: '다시 시도',
  canvasLabel: '편집 중인 이미지',
};

export const en: Messages = {
  pick: 'Choose photo',
  hint: 'JPG · PNG · WebP · up to 15MB',
  auto: 'Auto select',
  lasso: 'Lasso',
  modeReplace: 'New',
  modeAdd: 'Add',
  modeSubtract: 'Subtract',
  modeGroup: 'Lasso mode',
  applySel: 'Apply',
  cancelSel: 'Deselect',
  undoStep: 'Undo step',
  selHint: 'Refine the selection, then apply',
  refineOn: 'AI refine',
  refineOff: 'As drawn',
  refineGroup: 'Lasso refine mode',
  undo: 'Undo',
  redo: 'Redo',
  reset: 'Reset',
  resetView: 'Fit',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  zoomGroup: 'Zoom',
  save: 'Save PNG',
  another: 'Another photo',
  analyzing: 'Analyzing…',
  retry: 'Retry',
  canvasLabel: 'Image being edited',
};

export const locales = { ko, en };
export type Locale = keyof typeof locales;

export function resolveMessages(lang: Locale = 'ko', overrides?: Partial<Messages>): Messages {
  return { ...(locales[lang] ?? ko), ...overrides };
}
